import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import FormatQuoteIcon from "@mui/icons-material/FormatQuote";
import { Box, Button, FormControl, MenuItem, Paper, Select, SelectChangeEvent, Typography } from "@mui/material";
import { useState } from "react";
import { useCopyToClipBoard } from '../hooks/useCopyToClipBoard';

type citationFormats = "BibTeX" | "APA" | "MLA"

const citationFormatMapping: Record<citationFormats, string> = {
    "BibTeX": `@article{Husic_2022,
	doi = {10.1029/2022gl099898},
	url = {https://doi.org/10.1029%2F2022gl099898},
	year = 2022,
	month = {jul},
	publisher = {American Geophysical Union ({AGU})},
	author = {Admin Husic and Alexander Michalek},
	title = {Structural hillslope connectivity is driven by tectonics more than climate and modulates hydrologic extremes and benefits},
	journal = {Geophysical Research Letters}
}`,
    "APA": "Husic, A., & Michalek, A. (2022). Structural hillslope connectivity is driven by tectonics more than climate and modulates hydrologic extremes and benefits. Geophysical Research Letters. Portico. https://doi.org/10.1029/2022gl099898",
    "MLA": "Husic, Admin, and Alexander Michalek. “Structural Hillslope Connectivity Is Driven by Tectonics More than Climate and Modulates Hydrologic Extremes and Benefits.” Geophysical Research Letters, July 2022. Portico, Crossref, https://doi.org/10.1029/2022gl099898.",
}

export const Citation = () => {
    const { ref, copyToClipBoard } = useCopyToClipBoard()
    const [citationFormat, setCitationFormat] = useState<citationFormats>("APA")
    const [citation, setCitation] = useState(citationFormatMapping["APA"])

    const handleChange = (e: SelectChangeEvent) => {
        const format = e.target.value as citationFormats
        setCitationFormat(format)
        setCitation(citationFormatMapping[format])
    }

    return <Box sx={{ m: 2 }}>
        <Typography variant='h6'>
            <FormatQuoteIcon /> Cite
        </Typography>
        <Paper variant="outlined" sx={{ display: "flex", flexDirection: "column" }}>
            <FormControl fullWidth>
                <Select
                    value={citationFormat}
                    label="Citation Format"
                    onChange={handleChange}
                >
                    <MenuItem value={"APA"}>APA</MenuItem>
                    <MenuItem value={"MLA"}>MLA</MenuItem>
                    <MenuItem value={"BibTeX"}>BibTex</MenuItem>
                </Select>
            </FormControl>
            <Typography ref={ref} variant='body2' color="text.secondary" overflow="scroll">
                {citation}
            </Typography>
            <Button variant="outlined" fullWidth={false} onClick={copyToClipBoard} title="Copy Citation to Clipboard" sx={{
                alignSelf: "flex-end",
                m: 1,
                minWidth: 0,
                pl: 1,
                pr: 1
            }}>
                <ContentCopyIcon />
            </Button>
        </Paper>
    </Box>;
}
